import { DocumentNode, gql } from '@apollo/client';

export const DatabasesQueryByIdsGql: DocumentNode = gql`
query DatabasesByIds($first: Int!, $offset: Int!, $databaseIds: [ID]!) {
  databasesConnection(
    first: $first,
    offset: $offset,
    filter: { idWithin: $databaseIds }
  ) {
    totalCount
    nodes {
      ...DatabasesByIdsNodes
    }
  }
}

fragment DatabasesByIdsNodes on Database {
  id
  name
  controlledPermissionsEnabled: isControlledPermissionsEnabled
}
`;
